import { WebEnvironment } from './environment.model';

export const environment: WebEnvironment = {
  production: false,
  bppAuth: 'https://auth.dev.go-plattform.at',
  bppStella: 'https://stella.dev.go-plattform.at',
  bppFile: 'https://file.dev.go-plattform.at',
  bppChat: 'https://chat.dev.go-plattform.at',
  firebase: {
    apiKey: 'AIzaSyAdXVTlE6rz5QcJjQmR2kKm7df2tRC2Apo',
    authDomain: 'brokernet-8d771.firebaseapp.com',
    projectId: 'brokernet-8d771',
    storageBucket: 'brokernet-8d771.firebasestorage.app',
    messagingSenderId: '723625075079',
    appId: '1:723625075079:web:f422e20c44f41da8feb322',
    vapidKey: 'BMK8Gb5dMp5JTUbv8O8e0ws4_QL7hLkl-TyYrSlrYemr8FHnjQC4w2eRm2FQQ5Iztf0xK_W-hFduCpl6-5Om8pk'
  },
  auth: { enableAppleSignIn: true },
  appleAppStoreUrl: 'https://apps.apple.com/at/app/stella-2-0/id6736901146',
  playstoreUrl: 'https://play.google.com/store/apps/details?id=at.goplattform.app'
};
